import styled from "styled-components";

function getBackgroundColour(props) {
    if (props.disabled) {
        return props.theme.disabled;
    }

    if (props.inverted) {
        return props.theme.tertiary;
    }

    return props.theme.primary;
}

export const ModalButton = styled.button`
    background: ${props => getBackgroundColour(props)};
    border-radius: 0.2rem;
    color: ${props => (props.inverted ? props.theme.secondary : props.theme.tertiary)};
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    display: block;
    flex: 1 0 auto;
    font-family: vag-rounded-light, Helvetica, Arial, sans-serif;
    font-size: 1.4rem;
    margin: 0 2rem 1rem 0;
    max-width: 28rem;
    min-width: 10rem;
    padding: 0.8rem 1.5rem;
    position: relative;
    text-align: center;
    text-decoration: none;
    border: ${props => (props.inverted ? "1px solid #aaa" : "0px solid #aaa")};

    :focus {
        outline: 1px solid #80bcf9;
    }

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    }

    :last-of-type {
        margin-right: 0;
    }

    i {
        color: ${props => (props.inverted ? props.theme.primary : props.theme.tertiary)};
        display: inline-block;
        font-size: 1.5em;
        line-height: 0.75;
        position: absolute;
        right: 0.5rem;
    }
`;
